import React, { createContext, useState, useEffect, useContext, useCallback } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { 
  getFirestore, 
  doc, 
  getDoc, 
  collection, 
  query, 
  where, 
  getDocs, 
  collectionGroup 
} from "firebase/firestore";
import { app } from "../firebase";

const BarbeiroContext = createContext();

export function BarbeiroProvider({ children }) {
  const [barbeiro, setBarbeiro] = useState(null);
  const [loadingBarbeiro, setLoadingBarbeiro] = useState(true);
  const auth = getAuth(app);
  const db = getFirestore(app);

  const fetchBarbeiroData = useCallback(async (user) => {
    if (!user) {
      setBarbeiro(null);
      setLoadingBarbeiro(false);
      return;
    }

    try {
      setLoadingBarbeiro(true);
      
      // 1. Busca dados básicos do Lead
      const leadRef = doc(db, "leads", user.uid);
      const leadSnap = await getDoc(leadRef);
      let baseData = leadSnap.exists() ? leadSnap.data() : { uid: user.uid, email: user.email };

      let barbeariaId = null;
      let perfilBarbeiro = {};

      // 2. Tenta achar barbearia como DONO (Criador)
      const qDono = query(collection(db, "barbearia"), where("criadorUid", "==", user.uid));
      const snapDono = await getDocs(qDono);
      
      if (!snapDono.empty) {
        barbeariaId = snapDono.docs[0].id;
      } else {
        // 3. Se não é dono, procura em TODAS as barbearias onde ele pode ser funcionário
        // Usamos collectionGroup para buscar na subcoleção 'barbeiros' de qualquer barbearia
        const qFuncionario = query(collectionGroup(db, "barbeiros"), where("uid", "==", user.uid));
        const snapFuncionario = await getDocs(qFuncionario);

        if (!snapFuncionario.empty) {
          // Achou o cadastro dele em alguma barbearia
          const docRef = snapFuncionario.docs[0];
          // Pega o ID da barbearia através da referência do documento pai (barbearia -> barbeiros -> doc)
          // docRef.ref.parent.parent.id é o ID da barbearia
          barbeariaId = docRef.ref.parent.parent.id;
        }
      }

      // 4. Se achamos a barbearia, buscamos o perfil completo lá dentro
      if (barbeariaId) {
        const barbeiroRef = doc(db, `barbearia/${barbeariaId}/barbeiros`, user.uid);
        const barbeiroSnap = await getDoc(barbeiroRef);
        
        if (barbeiroSnap.exists()) {
          perfilBarbeiro = barbeiroSnap.data();
        }
      }

      // Mescla tudo. Garante que barbeariaId esteja presente.
      setBarbeiro({
        ...baseData,
        ...perfilBarbeiro,
        barbeariaId: barbeariaId // CRÍTICO: Isso permite checar o plano correto
      });

    } catch (error) {
      console.error("Erro ao carregar contexto:", error);
      setBarbeiro(null);
    } finally {
      setLoadingBarbeiro(false);
    }
  }, [db]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      fetchBarbeiroData(user);
    });
    return () => unsubscribe();
  }, [auth, fetchBarbeiroData]);

  const recarregarPerfil = async () => {
    if (auth.currentUser) await fetchBarbeiroData(auth.currentUser);
  };

  return (
    <BarbeiroContext.Provider value={{ barbeiro, loadingBarbeiro, recarregarPerfil }}>
      {children}
    </BarbeiroContext.Provider>
  );
}

export function useBarbeiro() {
  return useContext(BarbeiroContext);
}